import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserManagementService } from 'app/modules/user-management/services/user-management.service';
import module from 'app/modules/user-management/user-management.module'

@Component({
  selector: 'app-edit-user-modal',
  templateUrl: './edit-user-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-user-modal.component.scss']
})
export class EditUserModalComponent {
  public roles$ = this.userMangementService.roles$

  public userDetailsBody = {
    firstName: '',
    lastName: '',
    email: '',
    employeeId: '',
    jobTitle: '',
    department: '',
    roles: ['Super']
  }

  public roleList: any[] = []


  public selectedRoleList: string[] = [
     "Super"
  ]

  public isLoading: boolean = false;
  public isSuccess: boolean = false;


  constructor(
    public dialogRef: MatDialogRef<EditUserModalComponent>,
    @Inject(MAT_DIALOG_DATA) public userData: any,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private userMangementService: UserManagementService) { }

  ngOnInit(): void {
    this.selectedRoleList = this.userData.roles.map(res=> res.name)
    this.userDetailsBody = this.userData

    setTimeout(() => {
      this.getRoles()
    }, 500);
  }

  ngAfterViewInit() : void {
    this.cdr.detectChanges()
  }

  getRoles() {
    this.userMangementService.getRoles(1, 50).subscribe((res) => {
      this.roleList = res.data.data
    })
  }

  updateUser() {
    this.userDetailsBody = this.userData
    this.userDetailsBody.roles = this.getRolesId(this.selectedRoleList)

    this.userMangementService.updateUsersInfo(this.userDetailsBody).subscribe((res => {
      this.isSuccess = true
      this.closeDialog()
    }))
  }

  private getRolesId(roles): any[]{
    return roles.map(roleName => this.roleList.find(role => role.name === roleName));
  }

  isRolesChange(): boolean {
    // Check if selected permissions are equal to stored permissions or if loading
    return this.selectedRoleList.length === 0 ||
      JSON.stringify(this.selectedRoleList.sort()) === JSON.stringify(this.userData.roles.sort()) ||
      this.isLoading;
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }
}
